var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyoverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-1xwjee0",
    "aria-label": "house-smart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.842 8.299l-6-4.667a3 3 0 00-3.684 0l-6 4.667A2.998 2.998 0 003 10.667V18a3 3 0 003 3h12a3 3 0 003-3v-7.333c0-.926-.427-1.8-1.158-2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.238a5.655 5.655 0 01-8 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyoverview);
export default __webpack_public_path__ + "static/media/propertyoverview.ceef3cd7bc30754b48faf42cc1b92845.svg";
export { ForwardRef as ReactComponent };